import {Component, OnInit} from '@angular/core';
import {AlertListService, QueryStringService} from '@xref/ngx';
import {JwtHelperService} from '@auth0/angular-jwt';
import * as Cookies from 'js-cookie';
import constants from 'src/app/shared/constants';
import {OauthQuestionnaireService} from 'src/app/services/oauth-questionnaire/oauth-questionnaire.service';
import {IdService} from "../../services/id/id.service";

@Component({
    selector: 'xlog-oauth-questionnaire',
    templateUrl: './oauth-questionnaire.component.pug',
    styleUrls: ['./oauth-questionnaire.component.scss'],
    standalone: false
})
export class OauthQuestionnaireComponent implements OnInit {
    loaded = false;

    constructor(
        private id: IdService,
        private oauthQnr: OauthQuestionnaireService,
        private alertList: AlertListService,
        private queryString: QueryStringService,
        private jwtHelper: JwtHelperService
    ) {}

    ngOnInit() {
        if (this.id.ent_9105) {
            this.id.getAuthToken();
        }

        this.setRegionalUrl();

        this.autoConnect();
    }

    autoConnect() {
        const prompt = this.queryString.getParam('prompt');

        if (prompt === 'none') {
            // User does not need to click button, authorise straight away
            this.authorise();
        } else {
            this.loaded = true;
        }
    }

    authoriseSuccess = (res) => {
        if (res.data.redirect_uri)
            location.assign(res.data.redirect_uri);
        else
            this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    authoriseError = (res) => {
        console.error(res);
        this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    authorise() {
        this.oauthQnr.connectQuestionnaire().subscribe(this.authoriseSuccess, this.authoriseError);
    }

    logout() {
        this.id.logout();
    }

    setRegionalUrl() {
        const token = this.jwtHelper.decodeToken(this.id.ent_9105 ? sessionStorage.getItem(constants.AUTH_TOKEN)
            : Cookies.get(constants.AUTH_TOKEN));

        if (token && token.hasOwnProperty('region')) {
            this.oauthQnr.setRegionalUrl(token.region);
        }
    }
}
